var App = App || {};

App.WidgetSiteTour = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            const siteTour = selector;
            const siteTourModal = siteTour.parents(".modal");

            siteTourModal.find("button[data-bs-dismiss='modal']").on("click", function () {
                App.Cookies.setItem("AmericanEagle_SiteTour", "closed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            });

            siteTourModal.on("shown.bs.modal", function () {
                const carousel = siteTour.find(".splide");
                if (carousel.length) {
                    Carousel(carousel);
                }
            })
        }
    }

    function Carousel(carousel) {

        carousel.find("button[data-slide]").on("click", function () {

            var which = parseInt($(this).attr("data-slide"));

            if ($(this).parents(".splide").hasClass("splide--slide")) {
                splide.go(which);
            }
            else {
                const target = $(this).parents(".modal");
                const height = target.find(`.slide:nth-child(${which + 1})`).position().top;
                target.animate({ scrollTop: height }, 200);
            }

        });

        const current = carousel.find(".splide__status-current");
        const count = carousel.find(".splide__status-count");

        var splide = new Splide(carousel[0], {
            pagination: false,
            breakpoints: {
                991: {
                    destroy: true,
                },
            }
        });

        splide.on('mounted move', function () {
            current.text(splide.index + 1);
            count.text(splide.Components.Controller.getEnd() + 1);
        });

        splide.mount({});

    }

    return {
        Init: Init
    };

})(jQuery);